import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import About from './pages/About';
import Agreement from './pages/Agreement';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Main from './pages/Main';
import Policy from './pages/Policy';

function Router() {
  return (
    <BrowserRouter>
        <Header />
        <Routes>
            <Route index element={<Main />} />
            <Route path="/pages/gallery" element={<Gallery />} />
            <Route path="/pages/about" element={<About />} />
            <Route path="/pages/contact" element={<Contact />} />
            <Route path="/members/terms" element={<Agreement />} />
            <Route path="/members/policy" element={<Policy />} />
        </Routes>
        <Footer />
    </BrowserRouter>
  );
}

export default Router;
